export default "__VITE_ASSET__V4FkPqZx__"